import React, { useCallback, useContext, useState, useEffect, useRef } from 'react'
import OfferFilterDropdownBox from '../OfferFilterDropdownBox'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import LineNightIcon from 'LuxKit/Icons/line/LineNightIcon'
import { pluralizeToString } from 'lib/string/pluralize'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import OfferPageStateTrackingContext from 'contexts/OfferPage/offerPageStateTrackingContext'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import noop from 'lib/function/noop'

interface Props {
  duration: number
  checkInDate?: string
  inSidebar?: boolean
  open?: boolean
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  iconDisabled?: boolean
  ref?: React.Ref<HTMLButtonElement | HTMLDivElement>
}

function OfferDurationSelectBox(props: Props) {
  const { duration, checkInDate, open, onClick = noop, inSidebar, iconDisabled, ref } = props
  // Show a placeholder until we see the user actually select something or they interact with filter
  const [hasInteracted, setHasInteracted] = useState<boolean>(false)
  const initialDuration = useRef(duration)

  useEffect(() => {
    if ((checkInDate || duration !== initialDuration.current) && !hasInteracted) {
      setHasInteracted(true)
    }
  }, [checkInDate, duration, hasInteracted])

  const dispatch = useOfferPageDispatch()
  const { trackEvent } = useContext(OfferPageStateTrackingContext)
  const onBoxClick = useCallback<React.MouseEventHandler<HTMLButtonElement>>((e) => {
    setHasInteracted(true)
    if (open) {
      dispatch({ type: OfferPageActions.closeFilter })
      trackEvent('DURATION_FILTER_CLOSED')
    } else {
      trackEvent('DURATION_FILTER_PRESSED')
      dispatch({ type: OfferPageActions.toggleFilter, filter: 'duration' })
    }
    onClick(e)
  }, [dispatch, onClick, open, trackEvent])

  return <OfferFilterDropdownBox
    inSidebar={inSidebar}
    ref={ref}
    onClick={onBoxClick}
    icon={!iconDisabled && <LineNightIcon />}
    active={open}
    data-testid="OfferDurationSelectBox"
    label="Duration"
    placeholder="Select"
    value={(!hasInteracted && !inSidebar) ? undefined : <b>{pluralizeToString('night', duration)}</b>}
  />
}

export default withOfferPageState(state => ({
  duration: state.duration,
  checkInDate: state.checkInDate,
  open: state.activeFilter === 'duration',
}), OfferDurationSelectBox)
